import React, { useMemo } from 'react';
import GuidePopover from '../guidePopover';
import HasMaskFooter from './hasMaskFooter';
import styles from './hasMaskGuide.module.scss';
const HasMaskGuideContent = props => {
    const { show, position, showSideBar = false, borderRadius = 6, placement, showArrow, arrowDistance, title, intro = '', renderFooter, guideId, step, onStep, okText, onClose, className, keyboard, } = props;
    const archerStyle = useMemo(() => {
        if (!position) {
            return {};
        }
        return {
            left: showSideBar ? position.x - 68 : position.x,
            height: position.height,
            top: position.y,
            width: position.width,
            borderRadius,
        };
    }, [showSideBar, position]);
    const Content = () => {
        return (React.createElement("div", { className: styles.guideBobble },
            title && React.createElement("p", { className: styles.title }, title),
            typeof intro === 'string' ? (React.createElement("p", { className: styles.intro, hidden: !intro, style: title
                    ? {}
                    : {
                        marginTop: 0,
                    } }, intro)) : (intro),
            renderFooter ? renderFooter : React.createElement(HasMaskFooter, Object.assign({}, { guideId, step, onStep, okText, onClose, keyboard }))));
    };
    return (React.createElement(React.Fragment, null, show && position && (React.createElement("div", { className: `${styles.maskWrapper} global-marketing-modal ${className}`, style: { left: showSideBar ? '68px' : 0 }, onClick: e => e.stopPropagation() },
        React.createElement(GuidePopover, { type: "1", content: React.createElement(Content, null), placement: placement, visible: true, showArrow: showArrow, arrowDistance: arrowDistance },
            React.createElement("div", { className: styles.archerWrapper, style: archerStyle }))))));
};
export default HasMaskGuideContent;
